export default class AxiosForm {
  /**
   * Save form title
   *
   * @type {String}
   */
  static TITLE_TEXT = '';

  /**
   * Модуль отправки запросов форм
   *
   * @param {HTMLElement} form
   * @param {Element} title
   */
  static async sendForm(form, title, customParent = null) {
    if (form !== null && title !== null) {
      AxiosForm.TITLE_TEXT = title.textContent;
      const data = new FormData(form);
      const url = form?.action.replace(document.location.origin, '');
      const modal = (customParent !== null) ? customParent : form.closest('.form-ajax');
      const formBody = modal.querySelector('.modal-body') === null
        ? modal.querySelector('.form-body')
        : modal.querySelector('.modal-body');
      const successBody = modal.querySelector('.form-success-body');
      const errorBody = modal.querySelector('.form-error-body');

      AxiosForm.showLoading(modal, true);

      return window.axios[form?.method ?? 'POST'](url, data, {
        headers: { 'Content-Type': form?.enctype ?? 'multipart/form-data' },
      })
        .then((response) => {
          // TODO: Collect the event params into object
          AxiosForm.eventSuccess(response, formBody, successBody, title);
          AxiosForm.showLoading(modal, false);

          return response;
        })
        .catch((error) => {
          AxiosForm.eventError(error, formBody, errorBody, title);
          AxiosForm.showLoading(modal, false);

          return error;
        })
        .finally(() => {
          AxiosForm.eventFinally(modal, formBody, successBody, errorBody, title);
        });
    }
    return null;
  }

  /**
   * @param form
   * @param title
   * @returns {Promise<HTMLElement>}
   */
  static async getTemplate(data, form, title, customParent = null) {
    AxiosForm.TITLE_TEXT = title.textContent;
    const url = form?.action.replace(document.location.origin, '');
    const modal = (customParent !== null) ? customParent : form.closest('.form-ajax');
    const template = (customParent !== null) ? modal.querySelector('.template') : modal.closest('.template');

    AxiosForm.showLoading(modal, true);
    return window.axios
      .get(url, data, {
        method: form?.method ?? 'POST',
        headers: { 'Content-Type': form?.enctype ?? 'multipart/form-data' },
      })
      .then((response) => {
        template.innerHTML = response.data;
      })
      .then(() => template);
  }

  /**
   * @param {Promise} response
   * @param {Element} formBody
   * @param {Element} successBody
   * @param {Element} title
   */
  static eventSuccess(response, formBody, successBody, title) {
    const isRedirect = (formBody.querySelector('[data-no-redirect]') !== null);
    const isSendProducts = (formBody.querySelector('[data-send-products]') !== null);

    if (isSendProducts) {
      window.Dio.SHOP.CART.clear();
    }

    if (response?.status === 200 || response?.status === 201) {
      if (response?.data.id && !isRedirect) {
        title.textContent = 'Переход на страницу заказа';
        window.location.href = `/cart/order/final/${response.data.id}`;
      } else if (response?.data.id && isRedirect) {
        title.textContent = `Создан заказ №${response.data.id}`;
      } else {
        title.textContent = 'Сообщение отправлено';
        title.parentElement.classList.add('form-is-send');
      }
      AxiosForm.showMessageAfterSend(formBody, successBody);
    } else {
      title.textContent = 'Произошла ошибка на сервере при обработке заявки';
    }
    return response;
  }

  /**
   * @param {Promise} response
   * @param {Element} formBody
   * @param {Element} errorBody
   * @param {Element} title
   */
  static eventError(error, formBody, errorBody, title) {
    if (error?.response.status === 403) {
      title.textContent = error?.response.data.modal_title;
      errorBody.innerHTML = error?.response.data.modal_body;
    } else {
      title.textContent = 'Произошла ошибка! Нет соединения с сервером.';
    }
    AxiosForm.showMessageAfterSend(formBody, errorBody);
    return error.response;
  }

  /**
   * @param {Element} modal
   * @param {Element} formBody
   * @param {Element} successBody
   * @param {Element} errorBody
   * @param {Element} title
   */
  static eventFinally(modal, formBody, successBody, errorBody, title) {
    const subtitle = title.parentElement.querySelector('.form-subtitle') === null
      ? title.parentElement.querySelector('.modal-subtitle')
      : title.parentElement.querySelector('.form-subtitle');

    // TODO: Переделать говно
    if (subtitle) {
      subtitle.classList.add('d-none');
    }

    $(modal).on('hide.bs.modal', () => {
      $(modal).off('hide.bs.modal');

      setTimeout(() => {
        title.textContent = AxiosForm.TITLE_TEXT;
        modal.querySelector('form').reset();
        modal.querySelector('form').classList.remove('was-validated');
        // TODO: so many d-none
        formBody.classList.remove('d-none');
        successBody.classList.add('d-none');
        errorBody.classList.add('d-none');
        subtitle.classList.remove('d-none');
      }, 600);
    }); // replace if dont need jquery
  }

  /**
   * @param {Element} formBody
   * @param {Element} nextBody
   */
  static showMessageAfterSend(formBody, nextBody) {
    formBody.classList.add('d-none');
    nextBody.classList.remove('d-none');
  }

  /**
   * @param {Element} modal
   * @param {Boolean} state
   */
  static showLoading(modal, state) {
    const loader = modal.querySelector('.form-loading');

    if (loader !== null) {
      if (state) {
        loader.classList.remove('d-none');
      } else {
        loader.classList.add('d-none');
      }
    }
  }
}
